<template>
  <div>
<!--    <div class="input-group"  style="max-width:300px">-->
<!--      <input class="form-control py-2 border-right-0 border" type="search" v-model="filterWord">-->
<!--      <span class="input-group-append">-->
<!--        <div class="input-group-text bg-transparent"><i class="fa fa-search"></i></div>-->
<!--      </span>-->
<!--    </div>-->

    <ve-table ref="tableRef"  row-key-field-name="SystemId"
              :columns="columns"
              :table-data="tableData"
              :sort-option="sortOption"
              :expand-option="expandOption"
              :radio-option="radioOption"
              :checkbox-option="checkboxOption"
              :row-style-option="rowStyleOption"
              :cell-style-option="cellStyleOption"
              :editOption="editOption"
              :cellSelectionOption="cellSelectionOption"
               fixed-header
               border-y
    />


<!--    {{selectedRowKeys}}-->

<!--    <a role="button" class="btn btn-primary" @click="btnTest">Test</a>-->
<!--    <a role="button" class="btn btn-primary" @click="btnTest2">Test2</a>-->
<!--    <a role="button" class="btn btn-primary" @click="btnTest3">Test3</a>-->
  </div>
</template>

<script>/**
 columns
 { field: "name", key: "a", title: "Name", align: "center" },

 field: "material",
 title: "物料",
 width: 50,
 titleAlign: "center",
 columnAlign: "center",
 isFrozen: true,
 isResize: true


 fixed: "left" / "",
 type: "radio",
 type: "checkbox",
 type: "expand",      //出現一個  >  可以展開detail


 radio
 field: "radio",
 key: "radio",
 title: "",
 width: 100,
 fixed: this.enableColumnFixed ? "left" : "",
 type: "radio",

 field: "checkbox",
 key: "checkbox",
 title: "",
 width: 100,
 fixed: this.enableColumnFixed ? "left" : "",
 type: "checkbox",

 sortBy: "asc",

 edit: true,

 **/
import _ from "lodash";

export default {
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    datas: {
      type: Array,
      default: function () {
        return []
      }
    },
    config: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return {
          showColumnSeq:false,
          showColumnCheckBox:false,
          showColumnRadio:false,
        };
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      tableData:[],
      filterWord:"",
      filterDatasOrg:null,
      selectedRowKeys:[],
      rowStyleOption: {
        stripe: true,
      },
      sortOption: {
        sortAlways: true,
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      // sort change
      sortChange(params) {// eslint-disable-line
        let that=this;
        Object.entries(params).forEach(([key, value]) => {
          if (value){
            that.datas = _.orderBy(that.datas, [key],[value]);
          }
        });
      },
      radioOption: {
        selectedRowChange: ({ row }) => { // eslint-disable-line
          this.selectedRowKeys= row["SystemId"];
        },
      },
      checkboxOption: {
        // row select change event
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {  // eslint-disable-line
          //console.log(row, isSelected, selectedRowKeys);
          this.selectedRowKeys= selectedRowKeys;
          //
        },
        // selected all change event
        selectedAllChange: ({ isSelected, selectedRowKeys }) => { // eslint-disable-line
          //console.log(isSelected, selectedRowKeys);
          this.selectedRowKeys= selectedRowKeys;

        },
      },
      expandOption: {
        render: ({ row, column, rowIndex }, h) => { // eslint-disable-line
          // return (
          //     <p>
          //       Hello everyone, My name is{" "}
          //       <span style="font-weight:bold;">{row.name}</span>,
          //       I'm a {row.profession}. And I'm living in{" "}
          //       {row.address}.
          //     </p>
          // );
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => { // eslint-disable-line
          if (column.field === "proficiency") {
            return "table-body-cell-proficiency";
          }
        },
      },
      editOption: {
        // cell value change
        cellValueChange: ({ row, column }) => {
          console.log("cellValueChange row::", row);
          console.log("cellValueChange column::", column);
        },
      },
      cellSelectionOption: {
        // disble cell selection
        enable: false,
      },
      renderRowIndex({ row, column, rowIndex }) {// eslint-disable-line
        return rowIndex  + 1;
        //js x
        // return <span>{rowIndex + this.startRowIndex + 1}</span>;
      },

    };
  },
  methods: {
    async loadData() {

      if (this.config.showColumnSeq){
        this.addColunmSeq();
      }

      if (this.config.showColumnRadio){
        this.addColunmRadio();
      }

      if (this.config.showColumnCheckBox){
        this.addColunmCheckbox();
      }


      this.resetTableData();
    },
    addColunmSeq() {
      this.columns.unshift({
        field: "rowIndex",
        key: "rowIndex",
        title: "#",
        width: 100,
        fixed: "left" ,
        renderBodyCell: this.renderRowIndex,
      });
    },
    addColunmRadio() {
      this.columns.unshift({
        field: "radio",
        key: "radio",
        title: "",
        width: 100,
        fixed: "left" ,
        type: "radio",
      });
    },
    addColunmCheckbox() {
      this.columns.unshift({
        field: "checkbox",
        key: "checkbox",
        title: "",
        width: 100,
        fixed: "left" ,
        type: "checkbox",
      });
    },
    refreshTableData(data) {
      this.datas=data;
    },
    resetTableData() {
      this.tableData = this.datas.slice(0);
      this.tableData.pop();
      this.tableData = this.datas.slice(0);
    },
    filterData(){
      let that=this;

      if (that.filterWord){
        let arrayTmp=[];
        this.datas.forEach((item)=>{
          Object.keys(item).forEach(key => {
            if(item[key].includes(that.filterWord))
              arrayTmp.push(item)
          })
        })

        this.tableData=arrayTmp;
      }else{
        this.resetTableData();
      }
    },
    getSelectedRowKeys(){
      return this.selectedRowKeys;
    }

  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>

</style>
